<template>
  <b-modal id="alert-popup1"
           size="md"
           modal-class="client-details-modal"
           centered
           hide-header-close
           title="Your Current Plan"
           hide-footer>
    <b-button variant="close-btn" class='btn-container' @click="closeModal">
      <i class="fas fa-times"></i>
    </b-button>
    <div class="alert-popup">
      <p class="mb-4 text-center agreement-heading"><strong>Do you want to confirm below plans?</strong></p>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>Plans</th>
              <th>Renewal Rate</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ currentPlan.web_display_name }}</td>
              <td>{{ currentPlan.price | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="text-center">
        <button class="accept-btn" @click="keepPlan">
          {{ isKeep ? "Accepting..." : "Accept" }}
        </button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import Api from "@/resource/ApiV2";
export default {
  name: "DashboardEnrollmentCurrentPlanModal",
  props: {
    currentPlan: {
      required: true,
      type: Object,
    },
  },
  data: () => ({
    isKeep: false,
  }),
  methods: {
    keepPlan() {
      let url = `keep-plan`;
      let data = {
        current_plan_policy_id: this.currentPlan.plan_policy_id,
      };
      this.isKeep = true;
      Api.put(url, data)
        .then((res) => {
          this.$notify(res.data.message, 'success')
          this.$bvModal.hide("alert-popup1");
          this.$bvModal.hide("renewalPlanSwitchModal");
        })
        .catch((err) => {
          console.log(err)
          this.$notify('Something went wrong', 'error')
        })
        .finally(() => {
          this.isKeep = false;
        });
    },
    closeModal() {
      this.$bvModal.hide('alert-popup1')
    }
  },
};
</script>

<style>
#alert-popup1 .btn-container  {
  position: absolute;
  top: -75px !important;
  right: -12px;
  background: #fff;
  color: #000;
  border: 0;
  box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
  border-radius: 60px;
  font-size: 18px;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  display: flex;
}
</style>
